import React, { useState } from 'react';
import {
  Card,
  Col,
  Flex,
  Modal,
  Row,
  Typography,
  Image,
  Grid,
  Button,
} from 'antd';
import {
  CheckOutlined,
  ScheduleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons';
import { CDN_BASE_URL } from '../../../constants';
import { getCookie, setCookie } from '../../../utils/cookies';
import { t } from '../../../utils/i18n';
import { useGlobals } from '../../../globals-context';

const { useBreakpoint } = Grid;

export function PromotePayOnline() {
  const screens = useBreakpoint();
  const globals = useGlobals();
  const trackMethod = (globals as any)?.trackMethod || (() => {});
  const COUNTER_COOKIE_DURATION_DAYS = 90;

  const [isModalOpen, setIsModalOpen] = useState(true);

  const increaseShowPayOnlineCounter = () => {
    const counter = getCookie('showPromotePayOnlineCounter');
    setCookie(
      'showPromotePayOnlineCounter',
      counter ? parseInt(counter, 10) + 1 : 1,
      COUNTER_COOKIE_DURATION_DAYS,
    );
  };

  const handleActivateClick = () => {
    setIsModalOpen(false);

    // Track the activation click
    trackMethod('promote_pay_online_activate_clicked', {
      source: 'banner',
      action: 'activate',
    });

    increaseShowPayOnlineCounter();
    setCookie('showPromotePayOnline', 'false', 3);
  };

  const handleMaybeLater = () => {
    setIsModalOpen(false);

    // Track maybe later click
    trackMethod('promote_pay_online_maybe_later_clicked', {
      source: 'banner',
      action: 'maybe_later',
    });

    increaseShowPayOnlineCounter();
    setCookie('showPromotePayOnline', 'false', 14);
  };

  const handleCancel = () => {
    setIsModalOpen(false);

    // Track cancel/close click
    trackMethod('promote_pay_online_close_clicked', {
      source: 'banner',
      action: 'close',
    });

    increaseShowPayOnlineCounter();
    setCookie('showPromotePayOnline', 'false', 3);
  };

  // Track when the banner is shown
  React.useEffect(() => {
    if (isModalOpen) {
      trackMethod('promote_pay_online_banner_shown', {
        source: 'banner',
      });
    }
  }, [isModalOpen, trackMethod]);

  return (
    <Modal
      open={isModalOpen}
      centered
      title={null}
      footer={null}
      onCancel={handleCancel}
      width={{
        xs: '90%',
        sm: '80%',
        md: '70%',
        lg: '70%',
        xl: '60%',
        xxl: '50%',
      }}
    >
      <Row justify="center" style={{ marginBottom: '1.6rem' }}>
        <Col span={24} style={{ textAlign: 'center' }}>
          <Typography.Title level={3}>
            {t('banners.promote-pay-online.title')}
          </Typography.Title>
        </Col>
      </Row>
      <Row
        justify="center"
        gutter={[16, 16]}
        style={{ marginBottom: '1.6rem' }}
      >
        <Col xs={24} md={8} style={{ display: 'flex' }}>
          <Card
            style={{
              flex: 1,
              color: 'white',
              background:
                'linear-gradient(141.5deg, #B37FEB 5.29%, #391085 77.85%)',
            }}
          >
            <Typography.Title level={2} style={{ color: 'white', margin: 0 }}>
              0
            </Typography.Title>
            <Typography.Title
              level={5}
              style={{ color: 'white', margin: 0, marginBottom: '1.5rem' }}
            >
              {t('banners.promote-pay-online.no-shows.title')}{' '}
              <CloseCircleOutlined style={{ color: 'white' }} />
            </Typography.Title>
            <Typography.Text style={{ color: 'white' }}>
              {t('banners.promote-pay-online.no-shows.description')}
            </Typography.Text>
          </Card>
        </Col>
        <Col
          xs={24}
          md={8}
          style={{
            display: 'flex',
          }}
        >
          <Card
            style={{
              flex: 1,
              color: 'white',
              background:
                'linear-gradient(142.02deg, #5CDBD3 10.84%, #36CFC9 44.46%, #08979C 78.08%)',
            }}
          >
            <Typography.Title level={2} style={{ color: 'white', margin: 0 }}>
              100%
            </Typography.Title>
            <Typography.Title
              level={5}
              style={{ color: 'white', margin: 0, marginBottom: '1.5rem' }}
            >
              {t('banners.promote-pay-online.appointment-reliability.title')}{' '}
              <ScheduleOutlined style={{ color: 'white' }} />
            </Typography.Title>
            <Typography.Text style={{ color: 'white' }}>
              {t(
                'banners.promote-pay-online.appointment-reliability.description',
              )}
            </Typography.Text>
          </Card>
        </Col>
        <Col xs={24} md={8} style={{ display: 'flex' }}>
          <Card
            style={{
              flex: 1,
              color: 'white',
              background:
                'linear-gradient(141.5deg, #69B1FF 11.89%, #003EB3 77.85%)',
            }}
          >
            <Typography.Title level={2} style={{ color: 'white', margin: 0 }}>
              2-4hrs.
            </Typography.Title>
            <Typography.Title
              level={5}
              style={{ color: 'white', margin: 0, marginBottom: '1.5rem' }}
            >
              {t('banners.promote-pay-online.saved-time.title')}{' '}
              <ClockCircleOutlined style={{ color: 'white' }} />
            </Typography.Title>
            <Typography.Text style={{ color: 'white' }}>
              {t('banners.promote-pay-online.saved-time.description')}
            </Typography.Text>
          </Card>
        </Col>
      </Row>
      <Row justify="center" style={{ marginBottom: '1.6rem' }}>
        <Col span={24} style={{ textAlign: 'center' }}>
          <Card
            styles={{
              body: { padding: 0, overflow: 'hidden' },
              header: { padding: 0, marginBottom: 16 },
            }}
            style={{ border: 'none' }}
          >
            <Flex justify="space-between" gap={16}>
              {screens.md && (
                <Image
                  alt="picture"
                  src={`${CDN_BASE_URL}/images/banner_spon_bab.jpg`}
                  preview={false}
                  style={{ width: 500, display: 'block' }}
                />
              )}
              <Flex
                vertical
                align="flex-start"
                justify="center"
                style={{
                  padding: 32,
                  background: '#E6F4FF',
                  textAlign: 'left',
                }}
              >
                <Typography.Title
                  level={1}
                  style={{
                    margin: 0,
                    fontSize: '96px',
                    lineHeight: 0,
                    color: '#1677FF',
                  }}
                >
                  “
                </Typography.Title>
                <Typography.Title
                  level={4}
                  style={{ margin: 0, marginBottom: '2rem' }}
                >
                  {t('banners.promote-pay-online.testimony.text')}”
                </Typography.Title>
                <Typography.Text>
                  {t('banners.promote-pay-online.testimony.author')}
                </Typography.Text>
              </Flex>
            </Flex>
          </Card>
        </Col>
      </Row>
      <Row
        justify="center"
        style={{
          marginBottom: '1.6rem',
          border: '1px solid #eee',
          padding: '1rem',
        }}
      >
        <Col xs={24} md={12} style={{ textAlign: 'center' }}>
          <Flex
            gap={10}
            align="center"
            justify="center"
            style={{ width: '100%' }}
          >
            <CheckOutlined style={{ color: '#00d0be' }} />
            <Typography.Text>
              {t('banners.promote-pay-online.benefits.full-control')}
            </Typography.Text>
          </Flex>
        </Col>
        <Col xs={24} md={12} style={{ textAlign: 'center' }}>
          <Flex
            gap={10}
            align="center"
            justify="center"
            style={{ width: '100%' }}
          >
            <CheckOutlined style={{ color: '#00d0be' }} />
            <Typography.Text>
              {t('banners.promote-pay-online.benefits.low-fee')}
            </Typography.Text>
          </Flex>
        </Col>
      </Row>
      <Row
        gutter={[16, 24]}
        justify="center"
        style={{ marginBottom: '1.6rem' }}
      >
        <Col span={24} style={{ textAlign: 'center' }}>
          <Button
            type="primary"
            size="large"
            block
            href="/application-settings/payments?payment=shorepay"
            data-route
            onClick={handleActivateClick}
          >
            {t('banners.promote-pay-online.buttons.activate')}
          </Button>
        </Col>
        <Col span={24} style={{ textAlign: 'center' }}>
          <Button color="default" variant="link" onClick={handleMaybeLater}>
            {t('banners.promote-pay-online.buttons.maybe-later')}
          </Button>
        </Col>
      </Row>
    </Modal>
  );
}
